module.exports = __webpack_public_path__ + "static/media/Village-Manor-Bylaws.6e24575d.pdf";